import axiosInstance from "../config/axiosConfig";

// Use the global axios instance with interceptors
export const api = axiosInstance;

// API endpoints
export const candidateAPI = {
  getAll: (params) => api.get("/candidates", { params }),
  getCRM: (params) => api.get("/candidates/crm", { params }),
  search: (params) => api.get("/candidates/search", { params }),
  searchFacets: () => api.get("/candidates/search/facets"),
  create: (data) => api.post("/candidates", data),
  update: (id, data) => api.patch(`/candidates/${id}`, data),
  checkDuplicate: (params) => api.get("/candidates/check-duplicate", { params }),
  delete: (id) => api.delete(`/candidates/${id}`),
  bulkDelete: (ids) => api.post("/candidates/bulk-delete", ids),
  getOwnershipAssignees: (candidateIds) => api.post("/candidates/ownership/eligible-assignees", {
    candidate_ids: candidateIds,
  }),
  transferOwnership: (candidateIds, newOwnerId, expectedOwnerByCandidate) => api.post("/candidates/ownership/transfer", {
    candidate_ids: candidateIds,
    new_owner_id: newOwnerId,
    expected_owner_by_candidate: expectedOwnerByCandidate,
  }),
  uploadResume: (id, file) => {
    const formData = new FormData();
    formData.append("file", file);
    return api.post(`/upload/resume/${id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  downloadResume: (id, jdId = null) => api.get(`/candidates/${id}/resume`, {
    params: jdId ? { jd_id: jdId } : undefined,
    responseType: "blob",
  }),
};

export const candidateAccessRequestAPI = {
  create: (data) => api.post("/candidate-access-requests", data),
  list: (params) => api.get("/candidate-access-requests", { params }),
  approve: (id, data = {}) => api.post(`/candidate-access-requests/${id}/approve`, data),
  reject: (id, data = {}) => api.post(`/candidate-access-requests/${id}/reject`, data),
};

export const candidateAllocationAPI = {
  getEligibleRecruiters: (candidateId) => api.get('/candidate-allocations/eligible-recruiters', {
    params: { candidate_id: candidateId },
  }),
  direct: (data) => api.post('/candidate-allocations/direct', data),
  revoke: (allocationId, data) => api.post(`/candidate-allocations/${allocationId}/revoke`, data),
};

export const callLogAPI = {
  getAll: (params) => api.get("/call_logs", { params }),
  create: (data) => api.post("/call_logs", data),
};

export const uploadAPI = {
  bulkUpload: (file) => {
    const formData = new FormData();
    formData.append("file", file);
    return api.post("/upload/bulk", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  createCvBatch: (files) => {
    const formData = new FormData();
    files.forEach((file) => formData.append("files[]", file));
    return api.post("/upload/cv-bulk/batches", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  getLatestActiveCvBatch: () => api.get("/upload/cv-bulk/batches/latest/active"),
  getCvBatch: (batchId) => api.get(`/upload/cv-bulk/batches/${batchId}`),
  processNextCv: (batchId) => api.post(`/upload/cv-bulk/batches/${batchId}/process-next`),
  approveCvItem: (itemId, data) => api.post(`/upload/cv-bulk/items/${itemId}/approve`, data),
  skipCvItem: (itemId) => api.post(`/upload/cv-bulk/items/${itemId}/skip`),
};
